// Chinese

const lang = {
  gateMediaPreviewHeader: '您可能也喜欢',
  loadmore: '显示更多',
  nextMedia: '下一媒体',
  previousMedia: '上一媒体',
  closePost: '关闭贴文t',
  nextPost: '下一篇贴文',
  previousPost: '上一篇贴文',
  outOfStock: '缺货',
  numberOfReviews() {
    return '条评论'
  },
  reportFormField: '请输入信息',
  reportPost: '举报贴文',
  reportFormTitle: '您要举这张图片吗？',
  reportFormDetails:
    '如果您认为图片不宜、违法或侵犯他人的权利，可以举报该内容。如果您举报该图片/文字，我们将通知内容管理员，并采取适当的措施',
  reportFormMessagePlaceholder: '说明举报原因',
  reportFormMessageLabel: '留言',
  reportFormEmailLabel: '您的电子邮件',
  reportFormSubmitButtonText: '发送举报',
  reportFormCancelButtonText: '取消',
  reportFormSentTitle: '感谢您的举报！',
  reportFormSentCloseButtonText: '关闭',
  cardAndTileAriaLabel: '以下是各种社交媒体平台上帐户的帖子列表',
  carouselAriaLabel: '各种社交媒体账号所发布贴文的轮播如下',
  singleAriaLabel: '以下是来自社交媒体帐户的帖子',
  poweredBy: '由 Flowbox 提供技术支持',
  postAltText: (userName, date) => {
    const publishedString = date && !userName ? `于 ${date} 发布的照片` : ''
    const createdByString = userName && !date ? `${userName} 的照片` : ''
    const fullString = date && userName ? `${userName}于${date}发布的照片` : ''
    const photo = !date && !userName ? '照片' : ''
    return `${fullString}${photo}${createdByString}${publishedString}`
  },
  uploadYourMedia: '上传您的媒体',
  openTheGate: '開啟對話框',
}

export default lang
